webpackJsonp([54],{

/***/ "ToFj":
/***/ (function(module, exports, __webpack_require__) {

var SectionVideoSignUp = (function () {
    SectionVideoSignUp.$inject = ["$stateParams"];
    function SectionVideoSignUp($stateParams) {
        this.$stateParams = $stateParams;
        this.ltTitle = this.$stateParams.t || this.ltTitle;
        this.description = this.$stateParams.d || this.description;
        this.logo = _.isBoolean(this.logo) ? this.logo : true;
    }
    return SectionVideoSignUp;
}());
angular.module('animatronApp.sectionVideoSignUp', []).component('sectionVideoSignUp', {
    bindings: {
        logo: '<',
        ltTitle: '<',
        description: '<',
        background: '<',
        image: '<',
        video: '<',
        isScrollButton: '<'
    },
    controller: SectionVideoSignUp,
    templateUrl: __webpack_require__("WUbV")
});


/***/ }),

/***/ "WUbV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-video-sign-up_64f95369f2eafa6c4152fd462a8c0829.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/54-28dc41a6a889e793a2e2.min.js